import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { BannerImage } from '../BannerImage';
import { BannerText } from '../BannerText';
export const BannerFull = ({ text, image, textPosition = 'center', theme = 'dark', overlayBackground = overlayBackgroundValue[theme], }) => {
    const textPositionProps = getTextPositionProps();
    return (_jsxs(Box, { position: "relative", display: "flex", flexWrap: "wrap", alignItems: "stretch", minHeight: ['500px', null, null, '650px'], children: [_jsx(BannerImage, { root: {
                    pointerEvents: 'none',
                    ...image?.root,
                    ...parentSizeProps,
                }, imageBox: {
                    ...image?.imageBox,
                    ...parentSizeProps,
                }, overlayBackground: overlayBackground, ...image }), _jsx(BannerText, { root: {
                    p: [6, null, 16],
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    ...text?.root,
                    ...textPositionProps[textPosition],
                }, eyebrow: {
                    textStyle: ['Desktop/Eyebrow'],
                    textColor: theme === 'dark' ? ['text'] : ['background'],
                    ml: textPosition === 'center' ? 'auto' : undefined,
                    mr: textPosition === 'center' ? 'auto' : undefined,
                    ...text?.eyebrow,
                }, title: {
                    textStyle: ['Mobile/XL', null, 'Desktop/L', null, 'Desktop/XL'],
                    textColor: theme === 'dark'
                        ? ['text', null, 'text', null, 'text']
                        : ['background', null, 'background', null, 'background'],
                    ...text?.title,
                }, body: {
                    textStyle: ['Mobile/Body-L', null, 'Desktop/Body-L'],
                    textColor: theme === 'dark'
                        ? ['text', null, 'text', null, 'text']
                        : ['background', null, 'background', null, 'background'],
                    ...text?.body,
                }, ctaButtonBox: {
                    justifyContent: textPosition === 'center' ? 'center' : undefined,
                    ...text?.ctaButtonBox,
                }, ctaButtonPrimary: {
                    variant: theme === 'dark' ? 'solid' : 'solid-alt',
                    ...text?.ctaButtonPrimary,
                }, ctaButtonSecondary: {
                    variant: theme === 'dark' ? 'outline' : 'outline-alt',
                    ...text?.ctaButtonSecondary,
                }, ctaLinkBox: {
                    justifyContent: textPosition === 'center' ? 'center' : undefined,
                    ...text?.ctaButtonBox,
                }, ctaLinkItems: text?.ctaLinkItems?.map((el) => {
                    return {
                        variant: theme === 'dark' ? 'outline' : 'outline-alt',
                        ...text?.ctaButtonSecondary,
                        ...el,
                    };
                }) })] }));
};
const parentSizeProps = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
};
const getTextPositionProps = () => {
    return {
        left: {
            width: ['100%', '100%', '50%'],
        },
        center: {
            width: ['100%', '100%', '75%'],
            margin: '0 auto',
            textAlign: 'center',
        },
        right: {
            width: ['100%', '100%', '50%'],
            marginLeft: ['auto', 'auto', '50%'],
        },
    };
};
const overlayBackgroundValue = {
    light: 'rgba(0, 0, 0, 0.4)',
    dark: 'rgba(255, 255, 255, 0.2)',
};
